<template>
  <main class="not-found">
    <div class="container">
      <h2 class="not-found__title">503</h2>
      <h4>
        Не удалось запустить приложение. Обратитесь к администратору.
      </h4>
    </div>
  </main>
</template>

<script>

export default {
  name: "PageError503",

}
</script>

<style lang="scss">
.not-found {
  margin-bottom: 70px;
  height: 300px;
  position: relative;
  color: #00788C;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  &__title {
    font-size: 60px;
    font-weight: 800;
    margin-bottom: 30px;
  }
  &__text {
    font-size: 36px;
  }
  &__btns {
    margin-top: 30px;
    display: flex;
    justify-content: center;
  }

}
</style>